import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { TelephoneNumberSetFormPresentation } from './telephone-number-set-form-presentation';
import { TelephoneFormVM } from './telephone-form.viewmodel';
import { IZoomTelephoneNumberSetDTO } from '../../../api/zoom.dao';

interface IProps {
    fetchTelephoneNumberSets: () => void;
    closeTelephoneNumberSetForm: (id: string) => void;
    numberSet?: IZoomTelephoneNumberSetDTO;
}

const TelephoneFormContainer = withViewModel(
    TelephoneNumberSetFormPresentation,
    (props: IProps) => {
        const { fetchTelephoneNumberSets, closeTelephoneNumberSetForm, numberSet } = props;
        return new TelephoneFormVM(fetchTelephoneNumberSets, closeTelephoneNumberSetForm, numberSet);
    },
    () => []
);

export { TelephoneFormContainer as TelephoneNumberSetForm };
